module.exports = __webpack_public_path__ + "static/media/background.76d7dc3b.jpg";